/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Footer_SiteInputs */

const en_control_footer_site = /** @type {(inputs: Control_Footer_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site`)
};

const zh_control_footer_site = /** @type {(inputs: Control_Footer_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网站`)
};

/**
* | output |
* | --- |
* | "Site" |
*
* @param {Control_Footer_SiteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_footer_site = /** @type {((inputs?: Control_Footer_SiteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Footer_SiteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_footer_site(inputs)
	return zh_control_footer_site(inputs)
});
export { control_footer_site as "control.footer.site" }